var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProducingAreaUnSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 105.672,
    height: 83.832,
    viewBox: "0 0 105.672 83.832",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "farmer-farm-svgrepo-com",
    transform: "translate(0 -52.909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_895",
    "data-name": "Group 895",
    transform: "translate(30.108 52.909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_894",
    "data-name": "Group 894",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 10.222,
    cy: 10.222,
    r: 10.222,
    fill: "#625656"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_897",
    "data-name": "Group 897",
    transform: "translate(0 72.62)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_896",
    "data-name": "Group 896"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M82.487,205.111l-.234-3.3a4.645,4.645,0,0,0-1.744-3.308l-4.791-3.8a3.345,3.345,0,0,0-4.883.8l-5.223-4.147a5.237,5.237,0,0,0-2.3-5.335l-19.29-12.5L33.435,158.6l7.8,6.712,1.151-2.847a6.823,6.823,0,0,0-3.769-8.882l-11.557-4.671a6.824,6.824,0,0,0-8.892,3.794L5.477,184.462a8.7,8.7,0,0,0,3.738,10.767l8.233,4.741H6.281a6.281,6.281,0,1,0,0,12.562H43.966a6.287,6.287,0,0,0,2.817-11.895L18.156,186.27,31.6,189.138l1.766-4.369-8.473-20.111,11.165,15.735a5.236,5.236,0,0,0,1.422,1.364l20.132,13.05a5.23,5.23,0,0,0,5.753-.038l4.938,3.921-.211.266a3.325,3.325,0,0,0,.536,4.672l4.791,3.8a4.644,4.644,0,0,0,3.618.949l3.267-.519A2.6,2.6,0,0,0,82.487,205.111Z",
    transform: "translate(0 -148.411)",
    fill: "#625656"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_899",
    "data-name": "Group 899",
    transform: "translate(83.015 104.365)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_898",
    "data-name": "Group 898"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M424.052,310.8a16.514,16.514,0,0,0-8.812,3.358,19.5,19.5,0,0,1,2.431-7.957,2.017,2.017,0,0,0-.2-2.389l-.02-.023a2.02,2.02,0,0,0-3.237.276,18.359,18.359,0,0,0-1.617,3.44,16.9,16.9,0,0,0-6.068-5.2c-.775-.384-1.691.664-.661,1.433a13.967,13.967,0,0,1,1.449,1.283c5.058,5.062,3.623,9.005,3.624,13.408a16.833,16.833,0,0,0-7.826-3.4c-.854-.124-1.39,1.119-.183,1.568a12.914,12.914,0,0,1,8.586,9.608,10.417,10.417,0,0,0-5.406,6.958,1.186,1.186,0,0,0,1.159,1.44h13.047a1.187,1.187,0,0,0,1.159-1.44c-.623-2.838-2.928-6.131-5.874-7.139-.286-1.955-.457-3.746-.538-5.383a11.14,11.14,0,0,1,5.325-6.664,14.978,14.978,0,0,1,3.913-1.64A.779.779,0,0,0,424.052,310.8Z",
    transform: "translate(-402.224 -302.226)",
    fill: "#625656"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducingAreaUnSelected);
export default __webpack_public_path__ + "static/media/ProducingArea_UnSelected.8604768c1709d900954bf6adbfad7d99.svg";
export { ForwardRef as ReactComponent };